import { useContext, memo } from 'react';
import { Bar } from 'react-chartjs-2';
import type { ChartData, ChartOptions } from 'chart.js';
import { capacityChartOption, capacityChartData } from './capacityChartData';

import { AllInputDataContext, SliderValuesContext } from '../../../config';
import styles from './../AllCharts.module.css';

const CapacityChart = memo(() => {
  const allInputData = useContext(AllInputDataContext);
  const sliderValues = useContext(SliderValuesContext);

  const chartData = capacityChartData({
    allInputData,
    sliderValues
  });
  const chartOptions = capacityChartOption();

  return (
    <div className={styles.dataChart}>
      <div className={styles.chartInnerCard}>
        {/* Narrow the generic helper return to the bar chart at the boundary. */}
        <Bar
          data={chartData as ChartData<'bar'>}
          options={chartOptions as ChartOptions<'bar'>}
        />
      </div>
    </div>
  );
});
export default CapacityChart;
